export const modalConfig = {
    content: {
        width: "400px",
        padding: "0",
    },
};
